/* eslint-disable */
import { RouteConfig } from 'vue-router';
import { Roles } from '@/modules/authentication/models/rolesEnum';
import Analysis from '@/modules/analysis/Analysis.vue';
import NewAnalysis from '@/modules/analysis/views/NewAnalysis.vue';
import AnalysisDashboard from '@/modules/analysis/views/AnalysisDashboard.vue';
import DisplayAnalysis from '@/modules/analysis/views/DisplayAnalysis.vue';
import SampleBatchStatus from '@/modules/analysis/views/SampleBatchStatus.vue';

const routes: Array<RouteConfig> = [
  {
    path: '/analysis',
    name: 'Analysis',
    component: Analysis,
    redirect: { name: 'AnalysisDashboard' },
    meta: { requiredRole: Roles.requests_create },
    children: [
      {
        path: '/analysis/new',
        name: 'NewAnalysis',
        component: NewAnalysis,
        meta: {
          title: 'analysis.NewAnalysis.metaTitle'
        }
      },
      {
        path: '/analysis/dashboard',
        name: 'AnalysisDashboard',
        component: AnalysisDashboard,
        meta: {
          title: 'analysis.AnalysisDashboard.metaTitle'
        }
      },
      {
        path: '/analysis/:id',
        name: 'DisplayAnalysis',
        component: DisplayAnalysis,
        meta: {
          title: 'analysis.DisplayAnalysis.metaTitle'
        }
      },
      {
        path: '/analysis/batch/:id',
        name: 'SampleBatchStatus',
        component: SampleBatchStatus,
        meta: {
          title: 'analysis.SampleBatchStatus.metaTitle'
        }
      }
    ]
  }
];

export default routes;
